import React, { useState, useEffect } from "react";
import { Menu, X, Globe, ChevronRight } from "lucide-react";
import logo from "../../assets/Logo.png";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed w-full z-50 bg-[#F9F8F3] shadow-sm transition-all duration-300 ${
        isScrolled ? "py-3 shadow-md" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        {/* Logo Section */}
        <div className="flex items-center gap-3 cursor-pointer">
          {/* 
            FIX: Added fixed w-16 and h-16, flex centering, and shrink-0 
            so the circle never squishes into an oval.
          */}
          <div className="w-18 h-18 flex items-center justify-center bg-[#fffcd6] rounded-full shrink-0 p-2">
            <img
              src={logo}
              alt="CMJ Global Logo"
              className="w-18 h-18 object-contain"
            />
          </div>
          
          <div>
            <h1 className="font-['Montserrat'] text-2xl font-bold text-[#8B0304] tracking-wider leading-none">
              CMJ GLOBAL
            </h1>
            <p className="font-['Montserrat'] text-[10px] text-[#2C3539] font-semibold tracking-widest mt-1">
              MARINE SURVEYORS & CONSULTANTS
            </p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8 font-medium text-[#2C3539]">
          <a href="/" className="hover:text-[#87412A] transition-colors">
            Home
          </a>
          <a
            href="/services"
            className="hover:text-[#87412A] transition-colors"
          >
            Services
          </a>
          <a href="/about" className="hover:text-[#87412A] transition-colors">
            About Us
          </a>
          <a href="/contact" className="hover:text-[#87412A] transition-colors">
            Contact
          </a>

          {/* UPDATED: Desktop Get a Quote Link */}
          <a
            href="/contact"
            className="bg-[#87412A] text-white px-6 py-2.5 rounded-sm hover:bg-[#6b3321] transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
          >
            Get a Quote <ChevronRight size={16} />
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#1E4363]"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Navigation Dropdown */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-[#F9F8F3] shadow-lg border-t border-gray-200 flex flex-col py-4 px-6 gap-4">
          <a href="/" className="text-[#2C3539] font-medium">
            Home
          </a>
          <a href="/services" className="text-[#2C3539] font-medium">
            Services
          </a>
          <a href="/about" className="text-[#2C3539] font-medium">
            About Us
          </a>
          <a href="/contact" className="text-[#2C3539] font-medium">
            Contact
          </a>

          {/* UPDATED: Mobile Get a Quote Link */}
          <a
            href="/contact"
            className="bg-[#87412A] text-white px-4 py-2 rounded-sm w-full mt-2 text-center inline-block"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
}
